module.exports = __webpack_public_path__ + "img/firma-1.f0cb77bc.png";